<template>
  <div
    id="pageContainer"
    class="page-content"
  >
   <div class="search-box">
      <span class="f14">搜索你要查找的内容</span>
      <img src="/static/images/beautitysaid/se@2x.png" alt="" srcset="" />
    </div>
    <div class="circle-box-wrap" @click.stop="goIntegral" :style="{
      opacity:  showCircle ? '1' : '0.6'
    }">
      <div class="circle-box">
        <canvas id="canvas" width="48px" height="48px">您的浏览器不支持 HTML5 canvas 标签。</canvas>
        <img v-if="showGif" class="circle-gift-box-img" src="/static/images/beautitysaid/red.gif" />
        <img v-else class="circle-box-img" src="/static/images/beautitysaid/red.png" />
        <div class="btn-text">
          <span>{{ isreceive ? '今日已领' : '10金币' }}</span>
        </div>
      </div>
    </div>
     <VideoPlayer
      v-if="videoList.length"
      :ref="`videoPalyer`"
      :videoObj="videoList[active]"
      @timeupdate="handleTimeupdate"
      @cantouch="onCantouch"
      @showshare="e => showCircle = !e"
    ></VideoPlayer>
    <div ref="mySwiper" class="swiper-box" id="mySwiper">
      <div class="image-wrap" v-for="(obj, i) in videoList" :key="obj.key">
        <img
          :src="obj.coverimg + '?x-oss-process=image/resize,w_750/auto-orient,1'"
          style="width: 100vw;height: 100vh;object-fit: cover"
          alt=""
          srcset=""
        />
      </div>
    </div>
  </div>
</template>

<script>
let wh
const duration = 60
let mySwiperEle,pageContainer
let startY = 0
let touchmoveY = 0
let endY = 0
let positionY = 0
let startX = 0
let endX = 0
import VideoPlayer from './components/VideoPlayer.vue'
export default {
  components: {
    VideoPlayer
  },
  beforeRouteLeave(to, from, next) {
      console.log('from', from, to)
      if (to.path == '/beautitysaiddetail' || to.path == '/bs' || to.path == '/community') {
        from.meta.keepAlive = false
      }
      next();
  },
  activated() {
    console.log('deactivated',this.videoList, this.active)
    if (this.videoList.length) {
      this.$refs.videoPalyer.showControl()
    }
  },
  data() {
    return {
      videoList: [],
      active: 0,
      copyActive: 0,
      loading: false,
      allowTouchMove: this.$route.query.index ? true : false,
      params: {
        pagesize: 4,
        pageno: 1,
        index: this.$route.query.index,
        id: this.$route.query.cateid || '',
        type: 'down',
        itemid: this.$route.query.beautitysaidid
      },
      touchObj: {
        startY: 0,
        endY: 0
      },
      circleOpt: {
        precent: 100,
        num: 0,
        ratio: 0.25
      },
      startPI: -Math.PI / 2,
      endPi: -Math.PI / 2 + (2 * Math.PI) / duration, // 一个圆是 2 * Math.PI，一分钟转完除以 60
      animationId: null,
      viewingDuration: 0, // 观看时长
      redPngUrl: '/static/images/beautitysaid/red.png',
      showGif: false,
      isreceive: false,
      upFinish: false,
      downFinish: false,
      showCircle:true
    }
  },
  mounted() {
    if (this.$route.query.index) {
      this.getData(false)
    } else {
      this.getVideoPostById()
    }
    mySwiperEle = document.getElementById('mySwiper')
    pageContainer = document.getElementById('pageContainer')
    this.getReceiveCoinsStatus()
    this.bindEvent()
    wh = document.body.clientHeight
  },
  methods: {
    bindEvent() {
      pageContainer.addEventListener('touchstart', this.onTouchstart)
      pageContainer.addEventListener('touchmove', this.onTouchmove)
      pageContainer.addEventListener('touchend', this.onTouchend)
    },
    removeEvent() {
      pageContainer.removeEventListener('touchstart', this.onTouchstart)
      pageContainer.removeEventListener('touchmove', this.onTouchmove)
      pageContainer.removeEventListener('touchend', this.onTouchend)
    },
    onSwiperChange(index) {
      // 当滑动到倒数第1条视频的时候，再加载 10条数据
      if (this.active && this.active == this.videoList.length - 1) {
        this.params.itemid = this.videoList[this.active].id
        this.params.index = this.videoList[this.active].index
        this.params.type = 'down'
        if (!this.downFinish) {
          this.getData()
        }
      } else if (this.active == 0) {
        // 当滑动到第一条视频的时候
        this.params.itemid = this.videoList[this.active].id
        this.params.index = this.videoList[this.active].index
        this.params.type = 'up'
        if (!this.upFinish) {
          this.getData()
        }
      }
    },
    // 获取视频列表
    getData(remove = true) {
      this.allowTouchMove = false
      let url = this.$ajax.getVideoDetailPostList
      this.$customRequestAjax
        .get(url, {
          params: this.params
        })
        .then((res) => {
          this[this.params.type === 'down' ? 'downFinish' : 'upFinish'] =
            res.data.list.length < this.params.pagesize
          if (res.data.list.length) {
            res.data.list.forEach((item) => {
              item.key = Date.now() + '_' + item.index + '_' + item.id
            })
            if (this.params.type === 'down') {
              if (remove && res.data.list.length) {
                res.data.list.splice(0, 1)
              }
              this.videoList.push(...res.data.list)
            } else if (this.params.type === 'up') {
              this.videoList.unshift(...res.data.list.reverse())
            }
            this.$nextTick(() => {
              if (!remove) {
                 this.$refs.videoPalyer.showControl()
                this.onSwiperChange(0)
              } else {
                if (this.params.type === 'down') {
                  // this.$refs.videoPalyer.showControl()
                } else {
                  this.active = res.data.list.length
                  positionY = -1 * wh * this.active
                  mySwiperEle.style.transform = `translateY(${positionY}px)`
                  // this.$refs.videoPalyer.showControl()
                }
              }
            })
          }
          this.allowTouchMove = true
        })
        .catch((err) => {})
    },
    getVideoPostById() {
      let url = this.$ajax.getVideoPostById_URL
      this.$customRequestAjax
        .get(url, {
          params: {
            id: this.$route.query.beautitysaidid
          }
        })
        .then((res) => {
          this.videoList = [res.data.list]
          this.$nextTick(() => {
            this.$refs.videoPalyer.showControl()
          })
        })
    },
    onTouchstart(event) {
      console.log('touchstart', event)
      // event.stopPropagation()
      // event.preventDefault();
      if (this.allowTouchMove) {
        startY = event.touches[0].pageY
        startX = event.touches[0].pageX
      }
    },
    onTouchmove(e) {
      e.stopPropagation()
      e.preventDefault();
      if (this.allowTouchMove) {
        touchmoveY = e.changedTouches[0].pageY
        console.log('手指滑动', startY, touchmoveY)
        mySwiperEle.style.transform = `translateY(${positionY - (startY - touchmoveY)}px)`
        const videoEle = document.querySelector('.video-player-container')
        videoEle.style.top = `${0 - (startY - touchmoveY)}px`
        mySwiperEle.style.transitionDuration = `0s`
      }
    },
    onTouchend(e) {
      // e.stopPropagation()
      // e.preventDefault();
      if (!this.allowTouchMove) {
        return
      }
      let changeType = ''
      endY = e.changedTouches[0].pageY
      endX = e.changedTouches[0].pageX
      let iscontinue = true
      const videoEle = document.querySelector('.video-player-container')
      console.log('手指移开了', startY, endY)
      if (this.allowTouchMove && Math.abs(endY - startY) > 100) {
        // 如果向下滑动超过 200 则加载更多数据,只处理下拉加载
        if (endY > startY && endY - startY > 100) {
          if (this.active > 0) {
            this.active = this.active - 1
            changeType = 'up'
          } else {
            if (this.upFinish) {
              this.$toast('没有更多内容了')
            }
          }
        } else if (startY - endY > 100) {
          // 上拉加载
          if (this.active < this.videoList.length - 1) {
            this.active = this.active + 1
            changeType = 'down'
          } else {
            if (this.downFinish) {
              this.$toast('没有更多内容了')
            }
          }
        }
        setTimeout(() => {
          mySwiperEle.style.transitionProperty = `none`
          this.onSwiperChange(this.active)
        }, 400)
      } else if (Math.abs(endY - startY) < 5 && Math.abs(endX - startX) < 5) {
        iscontinue = false
        // this.$refs.videoPalyer.onVideoClick()
      }
      if (iscontinue) {
        positionY = -1 * wh * this.active
       
        mySwiperEle.style.transform = `translateY(${positionY}px)`
        mySwiperEle.style.transitionProperty = `transform`
        mySwiperEle.style.transitionDuration = `.4s`
        mySwiperEle.style.transitionTimingFunction = `ease`
        mySwiperEle.style.transitionDelay = `0s`
        if (changeType === 'down') {
          videoEle.style.top = `${-wh}px`
        } else if (changeType === 'up') {
          videoEle.style.top = `${wh}px`
        } else {
          videoEle.style.top = `0px`
        }
        // videoEle.style.transitionProperty = `top`
        // videoEle.style.transitionDuration = `.4s`
        // videoEle.style.transitionTimingFunction = `ease`
        // videoEle.style.transitionDelay = `0s`
        setTimeout(() => {
          videoEle.style.top = `0px`
          videoEle.style.transitionDuration = `0s`
          if (changeType) {
            this.$refs.videoPalyer.showControl()
          }
        }, 400)
      }
    },
    onCantouch(bol) {
      console.log('index', this.swiper)
      if (!bol) {
        this.bindEvent()
      } else {
        this.removeEvent()
      }
      // this.allowTouchMove = !bol
    },
    options(color, x, y, radius, start, end, order) {
      let c = document.getElementById('canvas')
      let ctx = c.getContext('2d')
      ctx.imageSmoothingEnabled = true;
      ctx.save()
      ctx.beginPath()
      ctx.lineCap = 'round'
      ctx.lineJoin = 'round'
      ctx.lineWidth = 2
      ctx.strokeStyle = color
      ctx.arc(x, y, radius, start, end, order) //x坐标,y坐标,半径,起始角,结束角,顺时针/逆时针
      ctx.stroke()
      ctx.closePath()
      ctx.restore()
      if (!this.isreceive) {
        this.startPI = this.endPi
        this.endPi = this.startPI + 2 * (Math.PI / duration)
      }
    },
    animate() {
      let c = document.getElementById('canvas')
      let ctx = c.getContext('2d')
      this.options('#FED83B ', 24, 24, 23, this.startPI, this.endPi)
    },
    // 跳转到金币页面
    goIntegral() {
      this.$app.goIntegralDetail()
    },
    // 获取金币领取状态
    getReceiveCoinsStatus() {
      const url = this.$ajax.receiveCoins
      this.$customRequestAjax
        .post(url, {
          isdone: 0
        })
        .then((res) => {
          console.log('isreceive', res, res.data.isreceive)
          this.isreceive = res.data.isreceive == '1'
          if (this.isreceive) {
            this.options('#FED83B ', 24, 24, 23, 0, 2 * Math.PI)
          }
        })
    },
    // 当视频播放时，画圆
    handleTimeupdate() {
      if (!this.isreceive) {
        console.log('this.startPI', this.startPI, Math.PI)
        if (this.viewingDuration < duration) {
          if (this.startPI.toFixed(2) < Math.PI * (1.5).toFixed(2)) {
            this.animate()
          }
          ++this.viewingDuration
          const url = this.$ajax.receiveCoins
          if (this.viewingDuration === duration) {
            this.$customRequestAjax
              .post(url, {
                isdone: 1
              })
              .then((res) => {
                this.isreceive = true
                this.showGif = true
                this.$toast('已领 10 金币')
                setTimeout(() => {
                  this.showGif = false
                }, 1000)
              })
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-content {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0px;
  left: 0px;
  .swiper-box {
    width: 100vw;
    overflow: hidden;
    transform: translateY(0px);
    .image-wrap {
      width: 100vw;
      height: 100vh;
      background-color: #333333;
    }
  }
  .video-player {
    width: 100vw !important;
    height: calc(100vh - constant(safe-area-inset-bottom)) !important;
    height: calc(100vh - env(safe-area-inset-bottom)) !important;
    background-size: cover;
    transition: all 0.5s;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 10;
  }
  .search-box {
    width: 3.3rem;
    height: 0.3rem;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 0.15rem;
    position: fixed;
    top: 0.07rem;
    left: 0.225rem;
    padding: 0px 0.12rem;
    z-index: 20;
    display: none;
    align-items: center;
    span {
      flex: 1;
      color: #ffffff;
      opacity: 0.6;
    }
    img {
      width: 0.2rem;
      opacity: 0.6;
    }
  }
  .refresh-box {
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 1;
    text-align: center;
  }
  .circle-box-wrap {
    position: fixed;
    top: .7rem;
    right: 11px;
    z-index: 100;
    border-radius: 50%;
    .circle-box {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 50%;
      canvas {
        width: 54px;
        height: 54px;
      }
      .circle-box-img {
        width: 48px;
        position: absolute;
        top: 3px;
        left: 3px;
      }
      .circle-gift-box-img {
        width: 48px;
        position: absolute;
        top: -24px;
        left: 3px;
      }
      .btn-text {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 72px;
        height: 22px;
        background: linear-gradient(270deg, #fa6562 0%, #fd535e 100%);
        border-radius: 12px;
        color: #ffffff;
        font-size: 12px;
        transform: scale(0.75);
        transform-origin: 0 0;
        position: absolute;
        left: 0px;
        bottom: -18px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/community-beautitysaid/detail.vue